export default __webpack_public_path__ + "static/media/Rodolfo1.083431f2.png";